import { useCallback, useEffect, useState } from 'react';
import { SOCIAL_POSTS_UPDATED_EVENT } from '../constants/socialPosts';
import { listActiveSocialPostGroups, type SocialPostUserGroup } from '../utils/socialPostsStorage';

export function useSocialPosts(): {
  groups: SocialPostUserGroup[];
  loading: boolean;
  refresh: () => void;
} {
  const [groups, setGroups] = useState<SocialPostUserGroup[]>([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(() => {
    void listActiveSocialPostGroups()
      .then((nextGroups) => {
        setGroups(nextGroups);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    refresh();
    const onUpdated = () => refresh();
    window.addEventListener(SOCIAL_POSTS_UPDATED_EVENT, onUpdated);
    return () => window.removeEventListener(SOCIAL_POSTS_UPDATED_EVENT, onUpdated);
  }, [refresh]);

  return { groups, loading, refresh };
}

export function notifySocialPostsUpdated(): void {
  window.dispatchEvent(new Event(SOCIAL_POSTS_UPDATED_EVENT));
}
